import classnames from 'classnames';

angular.module('shared').directive('htmlEditor', function() {
  return {
    restrict: 'E',
    template: require('templates/shared/html_editor.html.slim'),
    scope: {
      object: '=',
      onlyLink: '=',
      key: '@',
      titleKey: '=',
      placeholder: '@',
      mergeTags: '=',
      valueLabel: '=',
      titleLabel: '=',
      titleError: '=',
      error: '=',
      titleWrapperClass: '@',
      titleLabelClass: '@',
      titleInputClass: '@',
      mergeTagGroups: '=',
      hideToolbar: '=',
      plain: '=',
      disabled: '=',
      singleLine: '=',
      disableImage: '=',
      disableToggleHtml: '=',
      disableBold: '=',
      disableFontSelection: '=',
      disableColorPickers: '=',
      isSms: '=',
      isPushNotification: '='
    },
    controller: ["$scope", "$rootScope", function($scope, $rootScope) {
      $scope.toolbar = (function() {
        switch (false) {
          case !($scope.hideToolbar || $scope.plain):
            return [];
          case !$scope.onlyLink:
            return [['insertHttpsLink']];
          default:
            return [_.compact([!$scope.disableBold && 'bold', 'italics', 'underline', 'ul', 'ol', 'justifyLeft', 'justifyCenter', 'justifyRight', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', !$scope.disableImage && 'insertImage', !$scope.disableImage && 'insertAssetImage', 'insertHttpsLink'])];
        }
      })();
      $scope.editorClass = classnames({
        'form-control': true,
        'form-subject': $scope.singleLine
      });
      $scope.useNewEditor = $rootScope.gym.gym_config.use_slate_editor;
      $scope.onChange = function(val) {
        return $scope.object[$scope.key] = val;
      };
      if ($scope.titleKey) {
        return $scope.onTitleChange = function(val) {
          return $scope.object[$scope.titleKey] = val;
        };
      }
    }]
  };
});
